import React from 'react';

import '../../index.scss';

const NotFound = () => (
  <div className="container my-4 py-4">
    <h1>Page Not Found</h1>
    <p>Please try another page</p>
  </div>
);

export default NotFound;
